<template>
  <div>
    <h3>Pas hier afbeeldingen aan die op de hoofdpagina verschijnen</h3>
    <file-pond
      name="homeCarousel"
      label-idle="Drop een afbeelding hier..."
      allow-multiple="true"
      accepted-file-types="image/jpeg,image/png"
      :server="serverHomeCarousel"
      imageResizeTargetWidth="1600"
      imageResizeTargetHeight="1600"
      imageResizeMode="contain"
      :allowImageCrop="false"
      allowImageExifOrientation="true"
      :imageTransformVariants="thumbnail"
    ></file-pond>
    <hr>
    <p>Sleep afbeeldingen om de volgorde te wijzigen</p>
    <div class="card-columns">
      <draggable
        v-model="homeCarousel"
        @start="drag=true"
        @end="drag=false"
        scroll="true"
        scrollSensitivity="300"
        :scrollSpeed="50"
      >
        <!-- <div class="card-columns"> -->
        <progressive-img
          :key="idx"
          v-for="(item, idx) in sortedHomeCarousel"
          :placeholder="item.img_thumb"
          height="50"
          :aspect-ratio="item.ratio"
          class="card-img-top img-fluid"
          :src="item.img"
          alt
        ></progressive-img>
        <!-- </div> -->
      </draggable>
    </div>
    <!-- <vue-glide
      v-if="homeCarousel.length>0"
      :bullet="true"
      focusAt="center"
      :startAt="1"
      :perView="3"
      type="slider"
    >
      <vue-glide-slide v-for="(item, idx) in homeCarousel" :key="'img'+idx" class="align-self-center">
        <a href="#" @click="remove(item)">
          <progressive-img
            :src="item.img"
            alt
            class="img-fluid"
            :placeholder="item.img_thumb"
            :aspect-ratio="item.ratio"
          ></progressive-img>
        </a>
      </vue-glide-slide>
      <template slot="control">
        <button data-glide-dir="<"><</button>
        <button data-glide-dir=">">></button>
      </template>
    </vue-glide>-->
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";

let guid = () => {
  let s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4();
};
export default {
  data() {
    return { saving: undefined };
  },
  components: {
    draggable,
    filePond: () => import("./filepond")
  },
  computed: {
    // ...mapState(["homeCarousel"]),
    sortedHomeCarousel() {
      return this.$_.sortBy(this.homeCarousel, "order");
    },
    homeCarousel: {
      get() {
        return this.$store.state.homeCarousel;
      },
      set(val) {
        this.$_.forEach(val, async (x, idx) => {
          if (x.order != idx) {
            x.order = idx;
            await this.$firebase
              .firestore()
              .collection("homepage")
              .doc(x.id)
              .set(x);
          }
        });
        this.$store.commit("setHomeCarousel", val);
      }
    },
    thumbnail() {
      return {
        thumbnail_: transforms => {
          transforms.resize.size.width = 128;
          return transforms;
        }
      };
    },

    serverHomeCarousel() {
      return {
        process: (
          fieldName,
          file,
          metadataOrig,
          load,
          error,
          progress,
          abort
        ) => {
          if (!this.saving) this.saving = 0;
          this.saving -= 1;

          try {
            let metadata = { contentType: file.type };
            let ref = this.$firebase.storage().ref();
            let uid = guid();
            let thumbnail = this.$_.find(file, x => x.name == "thumbnail_");
            let large = this.$_.find(file, x => x.name != "thumbnail_");
            let task = ref.child(`/homepage/${uid}`).put(large.file, metadata);
            task.on(
              "state_changed",
              snapshot => {
                progress(
                  true,
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
                  100
                );
              },
              err => {
                this.$alertify.error(err);
                error();
              },
              async () => {
                let url = await task.snapshot.ref.getDownloadURL();
                let item = { img_id: uid };
                item.img = url;
                item.ratio =
                  parseFloat(metadataOrig.size.height) /
                  parseFloat(metadataOrig.size.width);
                if (metadataOrig.exif && metadataOrig.exif.orientation == 6)
                  item.ratio = 1 / item.ratio;
                var reader = new FileReader();
                reader.addEventListener(
                  "load",
                  async () => {
                    item.img_thumb = reader.result;
                    let resp = await this.$firebase
                      .firestore()
                      .collection("homepage")
                      .add(item);
                    load(resp.text);
                    this.saving += 1;
                    let snapshot = await this.$fb.collection("homepage").get();
                    let carousel = [];
                    snapshot.forEach(doc => {
                      let data = doc.data();
                      data.id = doc.id;
                      carousel.push(data);
                    });
                    this.$alertify.success("Foto succesvol toegevoegd!")
                    this.$store.commit("setHomeCarousel", carousel);
                  },
                  false
                );
                reader.readAsDataURL(thumbnail.file);
              }
            );
          } catch (err) {}
        }
      };
    }
  },
  methods: {
    remove({ id, img_id }) {
      this.$alertify.confirm("Zeker dat je deze wil verwijderen?", async () => {
        await this.$firebase
          .storage()
          .ref()
          .child(`homepage/${img_id}`)
          .delete();
        this.$firebase
          .firestore()
          .collection("homepage")
          .doc(id)
          .delete();
      });
    }
  }
};
</script>
